const namespaced = true

const state = {
  loading: false
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  }
}

const actions = {
  showLoading({ commit }) {
    commit('SET_LOADING', true)
  },
  hideLoading({ commit }) {
    commit('SET_LOADING', false)
  }
}

const getters = {
  getLoading: state => state.loading
}

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}
